const useQueryParams = () => {
  const queryParamsKey = 'queryParams';

  /**
   *
   * @param {string} newQueryParams
   */
  const setQueryParamsAndStore = (newQueryParams) => {
    localStorage.setItem(queryParamsKey, newQueryParams);
  };

  const clearQueryParams = () => {
    localStorage.removeItem(queryParamsKey);
  };
  return {
    getQueryParams: () => localStorage.getItem(queryParamsKey) ?? '',
    setQueryParams: setQueryParamsAndStore,
    clearQueryParams,
  };
};

/**
 *
 * @param {string} params
 * @returns {Record<string, any>}
 */
const parseQueryParams = (params) => {
  const res = {};
  if (!params) return res;
  const queryString = params[0] === '?' ? params.substring(1) : params;
  // eslint-disable-next-line no-restricted-syntax
  for (const param of queryString.split('&')) {
    const [key, value] = param.split('=');
    res[decodeURIComponent(key)] = JSON.parse(decodeURIComponent(value));
  }
  return res;
};

export { useQueryParams, parseQueryParams };
